export default "__VITE_ASSET__CWh2lm37__"